import { Button } from "@screener/uikit/components/button";
import { CenterScreen } from "@screener/uikit/components/center-screen";

/**
 * Экран вкладки, у которой поток забрала другая (§131 п. 3): поток один на
 * пользователя. Переподключения нет, пока человек сам не нажмёт «Открыть
 * здесь» — тогда поток уходит этой вкладке, а другая видит тот же экран.
 */
export function TakenOverScreen({ onOpenHere }: { onOpenHere: () => void }) {
  return (
    <CenterScreen>
      <div className="flex flex-col items-center gap-4">
        <p className="text-sm text-muted-foreground">Скринер открыт в другой вкладке</p>
        {/* Единственное действие экрана: фокус сразу на нём, Enter открывает поток. */}
        <Button variant="outline" size="sm" autoFocus onClick={onOpenHere}>
          Открыть здесь
        </Button>
      </div>
    </CenterScreen>
  );
}
